export default () => ({
  divider: {
    marginTop: '15px',
    marginBottom: '15px'
  },
  root: {
    // flexGrow: 1,
    padding: '30px'
  },
  anchorStyle: {
    cursor: 'pointer',
    textDecoration: 'underline',
    color: 'blue'
  },
  textField: {
    width: '90%'
  },
  addButton: {
    padding: '5px 40px',
    marginTop: '15px'
  },
  item: {
    marginBottom: '20px'
  },
  submitButton: {
    padding: '5px 40px',
    display: 'flex',
    margin: 'auto',
    marginTop: '20px'
  }
})
